// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 792 ? "main" : chunkId) + "." + {"792":"6a54e448","868":"6447844d"}[chunkId] + ".css";
};